import { render, staticRenderFns } from "./Employer.vue?vue&type=template&id=2b680912"
import script from "./Employer.vue?vue&type=script&lang=ts"
export * from "./Employer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports